import { styled } from '@metrika/ui-kit/emotion';
//todo better carbon breakpoint

export const ModalDialogText = styled.p`
   margin-top: 1rem;
`;

export const LoginButtonsHelp = styled.p`
   ${({ theme }) => theme.typo.bodyShort01}
   color: ${({ theme }) => theme.colors.text02};
   .cds--link {
      font-size: 0.875rem;
   }
`;

export const LoginTerms = styled.div`
   bottom: 2rem;
   position: absolute;
   width: 100%;
   margin: auto;
   padding: 0;

   p {
      ${({ theme }) => theme.typo.caption01}
      color: ${({ theme }) => theme.colors.text02};
      display: block;
      text-align: center;

      .cds--link {
         // Match link font size to "caption-01"
         font-size: 0.75rem;
      }
   }

   @media (min-width: 600px) {
      width: auto;
      right: 2rem;
   }
`;

export const LoginButtonsWrapper = styled.div`
   margin-left: 0;

   h1 {
      margin-bottom: 1rem;
   }

   .cds--btn {
      &:not(:last-of-type) {
         //  margin-bottom: 1rem;
         @media (min-width: ${({ theme }) => theme.mediaBreakpoints.md}) {
            // margin-bottom: 1.5rem;
         }
      }
      width: 100%;
   }

   @media (min-width: 600px) {
      margin-left: 3rem;
   }

   .cds--btn__icon {
      width: 1.25rem;
      height: 1.25rem;
   }

   .cds--btn__icon.microsoft {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='21'%3E%3Cpath fill='%23f25022' d='M1 1h9v9H1z'/%3E%3Cpath fill='%2300a4ef' d='M1 11h9v9H1z'/%3E%3Cpath fill='%237fba00' d='M11 1h9v9h-9z'/%3E%3Cpath fill='%23ffb900' d='M11 11h9v9h-9z'/%3E%3C/svg%3E");
   }

   .cds--btn__icon.google {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 48 48'%3E%3Cdefs%3E%3Cpath id='a' d='M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z'/%3E%3C/defs%3E%3CclipPath id='b'%3E%3Cuse xlink:href='%23a' overflow='visible'/%3E%3C/clipPath%3E%3Cpath clip-path='url(%23b)' fill='%23FBBC05' d='M0 37V11l17 13z'/%3E%3Cpath clip-path='url(%23b)' fill='%23EA4335' d='M0 11l17 13 7-6.1L48 14V0H0z'/%3E%3Cpath clip-path='url(%23b)' fill='%2334A853' d='M0 37l30-23 7.9 1L48 0v48H0z'/%3E%3Cpath clip-path='url(%23b)' fill='%234285F4' d='M48 48L17 24l-4-3 35-10z'/%3E%3C/svg%3E");
   }

   .cds--btn__icon.scb {
      background-image: url('/assets/images/scicon.svg');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
   }
`;

export const OtpInputWrapper = styled.div`
   // Monospace keeps every digit the same width, so a 6-digit code is easy to
   // scan and double-check against the email.
   .cds--text-input {
      font-family: 'IBM Plex Mono', monospace;
   }
`;

export const LoginLogosWrapper = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;

   margin-bottom: 1rem;
   margin-top: 1rem;

   // Move from middle
   margin-right: 3rem;

   .logo-metrika {
      max-width: 15rem;
   }

   p {
      ${({ theme }) => theme.typo.caption01}
      margin-top: 1rem;
      margin-bottom: 0.1rem;

      color: white;
      opacity: 0.75;
   }

   @media (max-width: 600px) {
      margin-right: 0;
      margin-top: 1rem;
      margin-bottom: 1rem;

      .logo-metrika {
         max-width: 12rem;
      }
   }
`;

export const LoginWrapper = styled.div`
   user-select: none;

   .login-left {
      position: relative;

      width: 100vw;

      display: flex;
      flex-direction: row;
      justify-content: center;

      align-items: flex-end;
      background-color: ${({ theme }) => (theme.name === 'dark' ? theme.rgba(theme.colors.ui01, 0.5) : '#0d152a')};

      padding: 2rem 0;
   }

   .login-right {
      position: relative;

      width: 100vw;

      display: flex;
      flex-direction: row;
      justify-content: center;

      align-items: flex-start;
      margin-top: 2rem;
   }

   @media (min-width: ${(props) => props.theme.mediaBreakpoints.md}) {
      .login-left {
         position: fixed;
         left: 0;
         top: 0;

         width: 50vw;
         height: 100vh;

         display: flex;
         flex-direction: column;
         justify-content: center;
         align-items: flex-end;
      }

      .login-right {
         position: fixed;
         // left: 0;
         top: 0;

         width: 50vw;
         height: 100vh;

         display: flex;
         flex-direction: column;
         justify-content: center;

         align-items: flex-start;
         left: 50vw;
         margin-top: 0;
      }
   }
`;
